import request from "../utils/request";

// let headers = {
//   'token':localStorage.getItem('token')
// }

// 登录
export function loginAccount(data) {
  return request({
    url: "/login/account",
    method: "post",
    data
  });
}

// 文件上传
export function uploadFile(data) {
  return request({
    url: "/upload/upload",
    method: "post",
    data
  });
}

// 工作台  数据
export function workbenchChart(params) {
  return request({
    url: "workbench/pieChart",
    method: "get",
    params
  });
}

// 工作台  列表
export function workbenchList(params) {
  return request({
    url: "workbench/TaskLibraryConfirmedPhoneLists",
    method: "get",
    params
  });
}
// 进度提示列表  列表
export function dxProgressLists(params) {
  return request({
    url: "/admin.admin/progressLists",
    method: "get",
    params
  });
}
//  ---------------------------------------- 管理员
// 管理员  列表
export function dxUserLists(params) {
  return request({
    url: "/admin.admin/lists",
    method: "get",
    params
  });
}
// 管理员  添加
export function dxaddUser(data) {
  return request({
    url: "/admin.admin/add",
    method: "post",
    data
  });
}
// 管理员  编辑
export function dxeditUser(data) {
  return request({
    url: "/admin.admin/edit",
    method: "post",
    data
  });
}
// 管理员  详情
export function dxdetailUser(params) {
  return request({
    url: "/admin.admin/detail",
    method: "get",
    params
  });
}
// 管理员  删除
export function dxdeleteUser(data) {
  return request({
    url: "/admin.admin/delete",
    method: "post",
    data
  });
}
// 用户  列表  分享码
export function dxYonghuShareCode(params) {
  return request({
    url: "/user.user/shareCode",
    method: "get",
    params
  });
}
// 用户  列表
export function dxYonghuLists(params) {
  return request({
    url: "/user.user/lists",
    method: "get",
    params
  });
}
// 用户  列表
export function dxYonghuListsvalid(params) {
  return request({
    url: "/user.user/validUserLists",
    method: "get",
    params
  });
}
// 用户  列表
export function dxYonghuDetail(params) {
  return request({
    url: "/user.user/detail",
    method: "get",
    params
  });
}
// 用户  列表
export function dxYonghuEdit(data) {
  return request({
    url: "/user.user/edit",
    method: "post",
    data
  });
}
// 管理员  列表
export function dxYonghuBidderLists(params) {
  return request({
    url: "/user.user/bidderLists",
    method: "get",
    params
  });
}

// 修改个人密码
export function dxeditPwdUser(data) {
  return request({
    url: "/admin.admin/editPassword",
    method: "post",
    data
  });
}

// 管理员  角色列表
export function dxrole(params) {
  return request({
    url: "/auth.role/all",
    method: "get",
    params
  });
}
// 机器人佣金  列表
export function dxRobotLists(params) {
  return request({
    url: "/robot_kickback.robot_kickback/lists",
    method: "get",
    params
  });
}
// 机器人佣金  添加
export function dxaddRobot(data) {
  return request({
    url: "/robot_kickback.robot_kickback/add",
    method: "post",
    data
  });
}
// 机器人佣金  编辑
export function dxeditRobot(data) {
  return request({
    url: "/robot_kickback.robot_kickback/edit",
    method: "post",
    data
  });
}
// 机器人佣金  详情
export function dxdetailRobot(params) {
  return request({
    url: "/robot_kickback.robot_kickback/detail",
    method: "get",
    params
  });
}
// 机器人佣金  删除
export function dxdeleteRobot(data) {
  return request({
    url: "/robot_kickback.robot_kickback/delete",
    method: "post",
    data
  });
}

//  ------------------------------------- 系统设置 -----------------------------------
// 系统设置  获取
export function dxgetpcConfig(params) {
  return request({
    url: "/config/getPCConfig",
    method: "get",
    params
  });
}

// 系统设置  设置
export function dxsetPcConfig(data) {
  return request({
    url: "/config/setPCConfig",
    method: "post",
    data
  });
}

// 系统设置  保证金  列表
export function dxAllMarginDeposit(params) {
  return request({
    url: "/user.user/getAllMarginDepositLists",
    method: "get",
    params
  });
}

// 系统设置 佣金  获取
export function dxgetKickback(params) {
  return request({
    url: "/config/getKickback",
    method: "get",
    params
  });
}

// 系统设置 佣金  设置
export function dxsetKickback(data) {
  return request({
    url: "/config/setKickback",
    method: "post",
    data
  });
}
// 系统设置 佣金  列表
export function dxUserKickback(params) {
  return request({
    url: "/user.user/getUserKickbackLists",
    method: "get",
    params
  });
}
// 系统设置 代拍规则  获取
export function dxgetProxyBidding(params) {
  return request({
    url: "/config/getProxyBidding",
    method: "get",
    params
  });
}

// 系统设置 代拍规则  设置
export function dxsetProxyBidding(data) {
  return request({
    url: "/config/setProxyBidding",
    method: "post",
    data
  });
}

// 系统设置 代拍规则  文件列表
export function dxsetProxyBiddingFileLists() {
  return request({
    url: "/proxy_bidding_file.proxy_bidding_file/lists",
    method: "get",
  });
}
// 系统设置 代拍规则  添加
export function dxsetProxyBiddingFileAdd(data) {
  return request({
    url: "/proxy_bidding_file.proxy_bidding_file/add",
    method: "post",
    data
  });
}
// 系统设置 代拍规则  删除
export function dxsetProxyBiddingFileEdit(data) {
  return request({
    url: "/proxy_bidding_file.proxy_bidding_file/edit",
    method: "post",
    data
  });
}
// 系统设置 代拍规则  编辑
export function dxsetProxyBiddingFileDel(data) {
  return request({
    url: "/proxy_bidding_file.proxy_bidding_file/delete",
    method: "post",
    data
  });
}

// 裂变管理 收取佣金 
export function dxgetRecycleKickback() {
  return request({
    url: "/config/getRecycleKickback",
    method: "get",
  });
}
// 裂变管理 收取佣金  编辑
export function dxsetRecycleKickback(data) {
  return request({
    url: "/config/setRecycleKickback",
    method: "post",
    data
  });
}
// 设置提醒 代拍规则  编辑
export function dxgetTaskReminder() {
  return request({
    url: "/config/getTaskReminder",
    method: "post",
  });
}
// 设置提醒 代拍规则  编辑
export function dxsetTaskReminder(data) {
  return request({
    url: "/config/setTaskReminder",
    method: "post",
    data
  });
}
// 用户收取佣金列表
export function dxgetUserRecycleKickbackLists(params) {
  return request({
    url: "/user.user/getUserRecycleKickbackLists",
    method: "get",
    params
  });
}
// 充值
export function dxgetPayQRCode(data) {
  return request({
    url: "/config/getPayQRCode",
    method: "post",
    data
  });
}
//  ------------------------------------- 机型档案 -----------------------------------
// 机型档案  手机系列  列表
export function dxphoneSeriesList(params) {
  return request({
    url: "/phone.phoneSeries/lists",
    method: "get",
    params
  });
}
// 机型档案  手机系列  有效列表
export function dxphoneSeriesValidlist(params) {
  return request({
    url: "/phone.phoneSeries/validLists",
    method: "get",
    params
  });
}
// 机型档案  手机系列  添加
export function dxphoneSeriesAdd(data) {
  return request({
    url: "/phone.phoneSeries/add",
    method: "post",
    data
  });
}
// 机型档案  手机系列  编辑
export function dxphoneSeriesEdit(data) {
  return request({
    url: "/phone.phoneSeries/edit",
    method: "post",
    data
  });
}
// 机型档案  手机系列  删除
export function dxphoneSeriesDel(data) {
  return request({
    url: "/phone.phoneSeries/delete",
    method: "post",
    data
  });
}

// 机型档案  手机机型  列表
export function dxphoneModelList(params) {
  return request({
    url: "/phone.phoneModel/lists",
    method: "get",
    params
  });
}
// 机型档案  手机机型  有效列表
export function dxphoneModelValidlist(params) {
  return request({
    url: "/phone.phoneModel/validLists",
    method: "get",
    params
  });
}
// 机型档案  手机机型  添加
export function dxphoneModelAdd(data) {
  return request({
    url: "/phone.phoneModel/add",
    method: "post",
    data
  });
}
// 机型档案  手机机型  编辑
export function dxphoneModelEdit(data) {
  return request({
    url: "/phone.phoneModel/edit",
    method: "post",
    data
  });
}
// 机型档案  手机机型  删除
export function dxphoneModelDel(data) {
  return request({
    url: "/phone.phoneModel/delete",
    method: "post",
    data
  });
}


// 机型档案  手机颜色  列表
export function dxphoneColorList(params) {
  return request({
    url: "/phone.phoneColor/lists",
    method: "get",
    params
  });
}
// 机型档案  手机机型  有效列表
export function dxphoneColorValidlist(params) {
  return request({
    url: "/phone.phoneColor/validLists",
    method: "get",
    params
  });
}
// 机型档案  手机颜色  添加
export function dxphoneColorAdd(data) {
  return request({
    url: "/phone.phoneColor/add",
    method: "post",
    data
  });
}
// 机型档案  手机颜色  编辑
export function dxphoneColorEdit(data) {
  return request({
    url: "/phone.phoneColor/edit",
    method: "post",
    data
  });
}
// 机型档案  手机颜色  删除
export function dxphoneColorDel(data) {
  return request({
    url: "/phone.phoneColor/delete",
    method: "post",
    data
  });
}
// 机型档案  手机颜色  详情
export function dxphoneColorDetail(params) {
  return request({
    url: "/phone.phoneColor/detail",
    method: "get",
    params
  });
}


//  ------------------------------------- 基本信息 -----------------------------------
// 基本信息  存储容量  列表
export function dxStorageList(params) {
  return request({
    url: "/base.baseStorageCapacity/lists",
    method: "get",
    params
  });
}
// 基本信息  存储容量  有效列表
export function dxStorageValidlist(params) {
  return request({
    url: "/base.baseStorageCapacity/validLists",
    method: "get",
    params
  });
}
// 基本信息  存储容量  添加
export function dxStorageAdd(data) {
  return request({
    url: "/base.baseStorageCapacity/add",
    method: "post",
    data
  });
}
// 基本信息  存储容量  编辑
export function dxStorageEdit(data) {
  return request({
    url: "/base.baseStorageCapacity/edit",
    method: "post",
    data
  });
}
// 基本信息  存储容量  删除
export function dxStorageDel(data) {
  return request({
    url: "/base.baseStorageCapacity/delete",
    method: "post",
    data
  });
}
// 基本信息  存储容量  详情
export function dxStorageDetail(params) {
  return request({
    url: "/base.baseStorageCapacity/detail",
    method: "get",
    params
  });
}


// 基本信息  保修期时长  列表
export function dxWarrantyList(params) {
  return request({
    url: "/base.baseWarrantyDuration/lists",
    method: "get",
    params
  });
}
// 基本信息  保修期时长  有效列表
export function dxWarrantyValidlist(params) {
  return request({
    url: "/base.baseWarrantyDuration/validLists",
    method: "get",
    params
  });
}
// 基本信息  保修期时长  添加
export function dxWarrantyAdd(data) {
  return request({
    url: "/base.baseWarrantyDuration/add",
    method: "post",
    data
  });
}
// 基本信息  保修期时长  编辑
export function dxWarrantyEdit(data) {
  return request({
    url: "/base.baseWarrantyDuration/edit",
    method: "post",
    data
  });
}
// 基本信息  保修期时长  删除
export function dxWarrantyDel(data) {
  return request({
    url: "/base.baseWarrantyDuration/delete",
    method: "post",
    data
  });
}
// 基本信息  保修期时长  详情
export function dxWarrantyDetail(params) {
  return request({
    url: "/base.baseWarrantyDuration/detail",
    method: "get",
    params
  });
}


// 基本信息  渠道  列表
export function dxChannelList(params) {
  return request({
    url: "/base.baseChannel/lists",
    method: "get",
    params
  });
}
// 基本信息  渠道  有效列表
export function dxChannelValidlist(params) {
  return request({
    url: "/base.baseChannel/validLists",
    method: "get",
    params
  });
}
// 基本信息  渠道  添加
export function dxChannelAdd(data) {
  return request({
    url: "/base.baseChannel/add",
    method: "post",
    data
  });
}
// 基本信息  渠道  编辑
export function dxChannelEdit(data) {
  return request({
    url: "/base.baseChannel/edit",
    method: "post",
    data
  });
}
// 基本信息  渠道  删除
export function dxChannelDel(data) {
  return request({
    url: "/base.baseChannel/delete",
    method: "post",
    data
  });
}
// 基本信息  渠道  详情
export function dxChannelDetail(params) {
  return request({
    url: "/base.baseChannel/detail",
    method: "get",
    params
  });
}


// 基本信息  电池  列表
export function dxBatteryList(params) {
  return request({
    url: "/base.baseBattery/lists",
    method: "get",
    params
  });
}
// 基本信息  电池  有效列表
export function dxBatteryValidlist(params) {
  return request({
    url: "/base.baseBattery/validLists",
    method: "get",
    params
  });
}
// 基本信息  电池  添加
export function dxBatteryAdd(data) {
  return request({
    url: "/base.baseBattery/add",
    method: "post",
    data
  });
}
// 基本信息  电池  编辑
export function dxBatteryEdit(data) {
  return request({
    url: "/base.baseBattery/edit",
    method: "post",
    data
  });
}
// 基本信息  电池  删除
export function dxBatteryDel(data) {
  return request({
    url: "/base.baseBattery/delete",
    method: "post",
    data
  });
}
// 基本信息  电池  详情
export function dxBatteryDetail(params) {
  return request({
    url: "/base.baseBattery/detail",
    method: "get",
    params
  });
}

//  ------------------------------------- 检修情况 -----------------------------------
// 检修情况  外观成色  机身  列表
export function dxChargeList(params) {
  return request({
    url: "/wgcs.wgcsFuselage/lists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  机身  有效列表
export function dxChargeValidlist(params) {
  return request({
    url: "/wgcs.wgcsFuselage/validLists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  机身  添加
export function dxChargeAdd(data) {
  return request({
    url: "/wgcs.wgcsFuselage/add",
    method: "post",
    data
  });
}
// 检修情况  外观成色  机身  编辑
export function dxChargeEdit(data) {
  return request({
    url: "/wgcs.wgcsFuselage/edit",
    method: "post",
    data
  });
}
// 检修情况  外观成色  机身  删除
export function dxChargeDel(data) {
  return request({
    url: "/wgcs.wgcsFuselage/delete",
    method: "post",
    data
  });
}
// 检修情况  外观成色  机身  详情
export function dxChargeDetail(params) {
  return request({
    url: "/wgcs.wgcsFuselage/detail",
    method: "get",
    params
  });
}

// 检修情况  外观成色  屏幕外观  列表
export function dxScreenSurfaceList(params) {
  return request({
    url: "/wgcs.wgcsScreenSurface/lists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  屏幕外观  有效列表
export function dxScreenSurfaceValidlist(params) {
  return request({
    url: "/wgcs.wgcsScreenSurface/validLists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  屏幕外观  添加
export function dxScreenSurfaceAdd(data) {
  return request({
    url: "/wgcs.wgcsScreenSurface/add",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕外观  编辑
export function dxScreenSurfaceEdit(data) {
  return request({
    url: "/wgcs.wgcsScreenSurface/edit",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕外观  删除
export function dxScreenSurfaceDel(data) {
  return request({
    url: "/wgcs.wgcsScreenSurface/delete",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕外观  详情
export function dxScreenSurfaceDetail(params) {
  return request({
    url: "/wgcs.wgcsScreenSurface/detail",
    method: "get",
    params
  });
}


// 检修情况  外观成色  屏幕显示  列表
export function dxScreenShowList(params) {
  return request({
    url: "/wgcs.wgcsScreenShow/lists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  屏幕显示  有效列表
export function dxScreenShowValidlist(params) {
  return request({
    url: "/wgcs.wgcsScreenShow/validLists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  屏幕显示  添加
export function dxScreenShowAdd(data) {
  return request({
    url: "/wgcs.wgcsScreenShow/add",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕显示  编辑
export function dxScreenShowEdit(data) {
  return request({
    url: "/wgcs.wgcsScreenShow/edit",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕显示  删除
export function dxScreenShowDel(data) {
  return request({
    url: "/wgcs.wgcsScreenShow/delete",
    method: "post",
    data
  });
}
// 检修情况  外观成色  屏幕显示  详情
export function dxScreenShowDetail(params) {
  return request({
    url: "/wgcs.wgcsScreenShow/detail",
    method: "get",
    params
  });
}


// 检修情况  外观成色  边框背板  列表
export function dxFrameBackboardList(params) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/lists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  边框背板  有效列表
export function dxFrameBackboardValidlist(params) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/validLists",
    method: "get",
    params
  });
}
// 检修情况  外观成色  边框背板  添加
export function dxFrameBackboardAdd(data) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/add",
    method: "post",
    data
  });
}
// 检修情况  外观成色  边框背板  编辑
export function dxFrameBackboardEdit(data) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/edit",
    method: "post",
    data
  });
}
// 检修情况  外观成色  边框背板  删除
export function dxFrameBackboardDel(data) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/delete",
    method: "post",
    data
  });
}
// 检修情况  外观成色  边框背板  详情
export function dxFrameBackboardDetail(params) {
  return request({
    url: "/wgcs.wgcsFrameBackboard/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况  电池  列表
export function dxCxBatteryList(params) {
  return request({
    url: "/cxqk.cxqkBattery/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  电池  有效列表
export function dxCxBatteryValidlist(params) {
  return request({
    url: "/cxqk.cxqkBattery/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  电池  添加
export function dxCxBatteryAdd(data) {
  return request({
    url: "/cxqk.cxqkBattery/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  电池  编辑
export function dxCxBatteryEdit(data) {
  return request({
    url: "/cxqk.cxqkBattery/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  电池  删除
export function dxCxBatteryDel(data) {
  return request({
    url: "/cxqk.cxqkBattery/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  电池  详情
export function dxCxBatteryDetail(params) {
  return request({
    url: "/cxqk.cxqkBattery/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况  前摄像头  列表
export function dxCxFrontCameraList(params) {
  return request({
    url: "/cxqk.cxqkFrontCamera/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  前摄像头  有效列表
export function dxCxFrontCameraValidlist(params) {
  return request({
    url: "/cxqk.cxqkFrontCamera/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  前摄像头  添加
export function dxCxFrontCameraAdd(data) {
  return request({
    url: "/cxqk.cxqkFrontCamera/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  前摄像头  编辑
export function dxCxFrontCameraEdit(data) {
  return request({
    url: "/cxqk.cxqkFrontCamera/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  前摄像头  删除
export function dxCxFrontCameraDel(data) {
  return request({
    url: "/cxqk.cxqkFrontCamera/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  前摄像头  详情
export function dxCxFrontCameraDetail(params) {
  return request({
    url: "/cxqk.cxqkFrontCamera/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况  后摄像头  列表
export function dxCxRearCameraList(params) {
  return request({
    url: "/cxqk.cxqkRearCamera/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  后摄像头  有效列表
export function dxCxRearCameraValidlist(params) {
  return request({
    url: "/cxqk.cxqkRearCamera/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况  后摄像头  添加
export function dxCxRearCameraAdd(data) {
  return request({
    url: "/cxqk.cxqkRearCamera/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  后摄像头  编辑
export function dxCxRearCameraEdit(data) {
  return request({
    url: "/cxqk.cxqkRearCamera/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  后摄像头  删除
export function dxCxRearCameraDel(data) {
  return request({
    url: "/cxqk.cxqkRearCamera/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况  后摄像头  详情
export function dxCxRearCameraDetail(params) {
  return request({
    url: "/cxqk.cxqkRearCamera/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况 后壳 列表
export function dxCxRearCaseList(params) {
  return request({
    url: "/cxqk.cxqkRearCase/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 后壳 有效列表
export function dxCxRearCaseValidlist(params) {
  return request({
    url: "/cxqk.cxqkRearCase/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 后壳 添加
export function dxCxRearCaseAdd(data) {
  return request({
    url: "/cxqk.cxqkRearCase/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 后壳 编辑
export function dxCxRearCaseEdit(data) {
  return request({
    url: "/cxqk.cxqkRearCase/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 后壳 删除
export function dxCxRearCaseDel(data) {
  return request({
    url: "/cxqk.cxqkRearCase/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 后壳 详情
export function dxCxRearCaseDetail(params) {
  return request({
    url: "/cxqk.cxqkRearCase/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况 功能零件 列表
export function dxCxFunctionalPartList(params) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 功能零件 有效列表
export function dxCxFunctionalPartValidlist(params) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 功能零件 添加
export function dxCxFunctionalPartAdd(data) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 功能零件 编辑
export function dxCxFunctionalPartEdit(data) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 功能零件 删除
export function dxCxFunctionalPartDel(data) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 功能零件 详情
export function dxCxFunctionalPartDetail(params) {
  return request({
    url: "/cxqk.cxqkFunctionalPart/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况 屏幕 列表
export function dxCxScreenList(params) {
  return request({
    url: "/cxqk.cxqkScreen/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 屏幕 有效列表
export function dxCxScreenValidlist(params) {
  return request({
    url: "/cxqk.cxqkScreen/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 屏幕 添加
export function dxCxScreenAdd(data) {
  return request({
    url: "/cxqk.cxqkScreen/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 屏幕 编辑
export function dxCxScreenEdit(data) {
  return request({
    url: "/cxqk.cxqkScreen/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 屏幕 删除
export function dxCxScreenDel(data) {
  return request({
    url: "/cxqk.cxqkScreen/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 屏幕 详情
export function dxCxScreenDetail(params) {
  return request({
    url: "/cxqk.cxqkScreen/detail",
    method: "get",
    params
  });
}

// 检修情况  拆修情况 主板 列表
export function dxCxMainboardList(params) {
  return request({
    url: "/cxqk.cxqkMainboard/lists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 主板 有效列表
export function dxCxMainboardValidlist(params) {
  return request({
    url: "/cxqk.cxqkMainboard/validLists",
    method: "get",
    params
  });
}
// 检修情况  拆修情况 主板 添加
export function dxCxMainboardAdd(data) {
  return request({
    url: "/cxqk.cxqkMainboard/add",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 主板 编辑
export function dxCxMainboardEdit(data) {
  return request({
    url: "/cxqk.cxqkMainboard/edit",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 主板 删除
export function dxCxMainboardDel(data) {
  return request({
    url: "/cxqk.cxqkMainboard/delete",
    method: "post",
    data
  });
}
// 检修情况  拆修情况 主板 详情
export function dxCxMainboardDetail(params) {
  return request({
    url: "/cxqk.cxqkMainboard/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 售后维修案例 列表
export function dxSyAfterSaleRepairList(params) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 售后维修案例 有效列表
export function dxSyAfterSaleRepairValidlist(params) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 售后维修案例 添加
export function dxSyAfterSaleRepairAdd(data) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 售后维修案例 编辑
export function dxSyAfterSaleRepairEdit(data) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 售后维修案例 删除
export function dxSyAfterSaleRepairDel(data) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 售后维修案例 详情
export function dxSyAfterSaleRepairDetail(params) {
  return request({
    url: "/sygn.sygnAfterSaleRepair/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 开机情况等 列表
export function dxSyPowerOnStatusList(params) {
  return request({
    url: "/sygn.sygnPowerOnStatus/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 开机情况等 有效列表
export function dxSyPowerOnStatusValidlist(params) {
  return request({
    url: "/sygn.sygnPowerOnStatus/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 开机情况等 添加
export function dxSyPowerOnStatusAdd(data) {
  return request({
    url: "/sygn.sygnPowerOnStatus/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 开机情况等 编辑
export function dxSyPowerOnStatusEdit(data) {
  return request({
    url: "/sygn.sygnPowerOnStatus/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 开机情况等 删除
export function dxSyPowerOnStatusDel(data) {
  return request({
    url: "/sygn.sygnPowerOnStatus/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 开机情况等 详情
export function dxSyPowerOnStatusDetail(params) {
  return request({
    url: "/sygn.sygnPowerOnStatus/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 是否可恢复出厂设置 列表
export function dxSyRestoreFactorySettingsList(params) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 是否可恢复出厂设置 有效列表
export function dxSyRestoreFactorySettingsValidlist(params) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 是否可恢复出厂设置 添加
export function dxSyRestoreFactorySettingsAdd(data) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 是否可恢复出厂设置 编辑
export function dxSyRestoreFactorySettingsEdit(data) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 是否可恢复出厂设置 删除
export function dxSyRestoreFactorySettingsDel(data) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 是否可恢复出厂设置 详情
export function dxSyRestoreFactorySettingsDetail(params) {
  return request({
    url: "/sygn.sygnRestoreFactorySettings/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 前摄拍照摄像 列表
export function dxSyFrontCameraList(params) {
  return request({
    url: "/sygn.sygnFrontCamera/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 前摄拍照摄像 有效列表
export function dxSyFrontCameraValidlist(params) {
  return request({
    url: "/sygn.sygnFrontCamera/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 前摄拍照摄像 添加
export function dxSyFrontCameraAdd(data) {
  return request({
    url: "/sygn.sygnFrontCamera/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 前摄拍照摄像 编辑
export function dxSyFrontCameraEdit(data) {
  return request({
    url: "/sygn.sygnFrontCamera/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 前摄拍照摄像 删除
export function dxSyFrontCameraDel(data) {
  return request({
    url: "/sygn.sygnFrontCamera/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 前摄拍照摄像 详情
export function dxSyFrontCameraDetail(params) {
  return request({
    url: "/sygn.sygnFrontCamera/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 后摄拍照摄像 列表
export function dxSyRearCameraList(params) {
  return request({
    url: "/sygn.sygnRearCamera/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 后摄拍照摄像 有效列表
export function dxSyRearCameraValidlist(params) {
  return request({
    url: "/sygn.sygnRearCamera/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 后摄拍照摄像 添加
export function dxSyRearCameraAdd(data) {
  return request({
    url: "/sygn.sygnRearCamera/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 后摄拍照摄像 编辑
export function dxSyRearCameraEdit(data) {
  return request({
    url: "/sygn.sygnRearCamera/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 后摄拍照摄像 删除
export function dxSyRearCameraDel(data) {
  return request({
    url: "/sygn.sygnRearCamera/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 后摄拍照摄像 详情
export function dxSyRearCameraDetail(params) {
  return request({
    url: "/sygn.sygnRearCamera/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 通话功能 列表
export function dxSyCallList(params) {
  return request({
    url: "/sygn.sygnCall/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 通话功能 有效列表
export function dxSyCallValidlist(params) {
  return request({
    url: "/sygn.sygnCall/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 通话功能 添加
export function dxSyCallAdd(data) {
  return request({
    url: "/sygn.sygnCall/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 通话功能 编辑
export function dxSyCallEdit(data) {
  return request({
    url: "/sygn.sygnCall/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 通话功能 删除
export function dxSyCallDel(data) {
  return request({
    url: "/sygn.sygnCall/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 通话功能 详情
export function dxSyCallDetail(params) {
  return request({
    url: "/sygn.sygnCall/detail",
    method: "get",
    params
  });
}


// 检修情况  使用功能 声音功能 列表
export function dxSySoundList(params) {
  return request({
    url: "/sygn.sygnSound/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 声音功能 有效列表
export function dxSySoundValidlist(params) {
  return request({
    url: "/sygn.sygnSound/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 声音功能 添加
export function dxSySoundAdd(data) {
  return request({
    url: "/sygn.sygnSound/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 声音功能 编辑
export function dxSySoundEdit(data) {
  return request({
    url: "/sygn.sygnSound/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 声音功能 删除
export function dxSySoundDel(data) {
  return request({
    url: "/sygn.sygnSound/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 声音功能 详情
export function dxSySoundDetail(params) {
  return request({
    url: "/sygn.sygnSound/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 icloud是否注销 列表
export function dxSyIcloudList(params) {
  return request({
    url: "/sygn.sygnIcloud/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 icloud是否注销 有效列表
export function dxSyIcloudValidlist(params) {
  return request({
    url: "/sygn.sygnIcloud/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 icloud是否注销 添加
export function dxSyIcloudAdd(data) {
  return request({
    url: "/sygn.sygnIcloud/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 icloud是否注销 编辑
export function dxSyIcloudEdit(data) {
  return request({
    url: "/sygn.sygnIcloud/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 icloud是否注销 删除
export function dxSyIcloudDel(data) {
  return request({
    url: "/sygn.sygnIcloud/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 icloud是否注销 详情
export function dxSyIcloudDetail(params) {
  return request({
    url: "/sygn.sygnIcloud/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 充电功能 列表
export function dxSyChargingList(params) {
  return request({
    url: "/sygn.sygnCharging/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 充电功能 有效列表
export function dxSyChargingValidlist(params) {
  return request({
    url: "/sygn.sygnCharging/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 充电功能 添加
export function dxSyChargingAdd(data) {
  return request({
    url: "/sygn.sygnCharging/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 充电功能 编辑
export function dxSyChargingEdit(data) {
  return request({
    url: "/sygn.sygnCharging/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 充电功能 删除
export function dxSyChargingDel(data) {
  return request({
    url: "/sygn.sygnCharging/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 充电功能 详情
export function dxSyChargingDetail(params) {
  return request({
    url: "/sygn.sygnCharging/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 无线功能 列表
export function dxSyWirelessList(params) {
  return request({
    url: "/sygn.sygnWireless/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 无线功能 有效列表
export function dxSyWirelessValidlist(params) {
  return request({
    url: "/sygn.sygnWireless/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 无线功能 添加
export function dxSyWirelessAdd(data) {
  return request({
    url: "/sygn.sygnWireless/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 无线功能 编辑
export function dxSyWirelessEdit(data) {
  return request({
    url: "/sygn.sygnWireless/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 无线功能 删除
export function dxSyWirelessDel(data) {
  return request({
    url: "/sygn.sygnWireless/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 无线功能 详情
export function dxSyWirelessDetail(params) {
  return request({
    url: "/sygn.sygnWireless/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 指南针功能 列表
export function dxSyCompassList(params) {
  return request({
    url: "/sygn.sygnCompass/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 指南针功能 有效列表
export function dxSyCompassValidlist(params) {
  return request({
    url: "/sygn.sygnCompass/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 指南针功能 添加
export function dxSyCompassAdd(data) {
  return request({
    url: "/sygn.sygnCompass/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 指南针功能 编辑
export function dxSyCompassEdit(data) {
  return request({
    url: "/sygn.sygnCompass/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 指南针功能 删除
export function dxSyCompassDel(data) {
  return request({
    url: "/sygn.sygnCompass/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 指南针功能 详情
export function dxSyCompassDetail(params) {
  return request({
    url: "/sygn.sygnCompass/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 触摸功能 列表
export function dxSyTouchList(params) {
  return request({
    url: "/sygn.sygnTouch/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 触摸功能 有效列表
export function dxSyTouchValidlist(params) {
  return request({
    url: "/sygn.sygnTouch/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 触摸功能 添加
export function dxSyTouchAdd(data) {
  return request({
    url: "/sygn.sygnTouch/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 触摸功能 编辑
export function dxSyTouchEdit(data) {
  return request({
    url: "/sygn.sygnTouch/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 触摸功能 删除
export function dxSyTouchDel(data) {
  return request({
    url: "/sygn.sygnTouch/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 触摸功能 详情
export function dxSyTouchDetail(params) {
  return request({
    url: "/sygn.sygnTouch/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 面容识别功能 列表
export function dxSyFacialRecognitionList(params) {
  return request({
    url: "/sygn.sygnFacialRecognition/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 面容识别功能 有效列表
export function dxSyFacialRecognitionValidlist(params) {
  return request({
    url: "/sygn.sygnFacialRecognition/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 面容识别功能 添加
export function dxSyFacialRecognitionAdd(data) {
  return request({
    url: "/sygn.sygnFacialRecognition/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 面容识别功能 编辑
export function dxSyFacialRecognitionEdit(data) {
  return request({
    url: "/sygn.sygnFacialRecognition/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 面容识别功能 删除
export function dxSyFacialRecognitionDel(data) {
  return request({
    url: "/sygn.sygnFacialRecognition/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 面容识别功能 详情
export function dxSyFacialRecognitionDetail(params) {
  return request({
    url: "/sygn.sygnFacialRecognition/detail",
    method: "get",
    params
  });
}


// 检修情况  使用功能 屏幕传感器功能 列表
export function dxSyScreenSensorList(params) {
  return request({
    url: "/sygn.sygnScreenSensor/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 屏幕传感器功能 有效列表
export function dxSyScreenSensorValidlist(params) {
  return request({
    url: "/sygn.sygnScreenSensor/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 屏幕传感器功能 添加
export function dxSyScreenSensorAdd(data) {
  return request({
    url: "/sygn.sygnScreenSensor/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 屏幕传感器功能 编辑
export function dxSyScreenSensorEdit(data) {
  return request({
    url: "/sygn.sygnScreenSensor/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 屏幕传感器功能 删除
export function dxSyScreenSensorDel(data) {
  return request({
    url: "/sygn.sygnScreenSensor/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 屏幕传感器功能 详情
export function dxSyScreenSensorDetail(params) {
  return request({
    url: "/sygn.sygnScreenSensor/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 震动功能 列表
export function dxSyVibrationList(params) {
  return request({
    url: "/sygn.sygnVibration/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 震动功能 有效列表
export function dxSyVibrationValidlist(params) {
  return request({
    url: "/sygn.sygnVibration/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 震动功能 添加
export function dxSyVibrationAdd(data) {
  return request({
    url: "/sygn.sygnVibration/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 震动功能 编辑
export function dxSyVibrationEdit(data) {
  return request({
    url: "/sygn.sygnVibration/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 震动功能 删除
export function dxSyVibrationDel(data) {
  return request({
    url: "/sygn.sygnVibration/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 震动功能 详情
export function dxSyVibrationDetail(params) {
  return request({
    url: "/sygn.sygnVibration/detail",
    method: "get",
    params
  });
}

// 检修情况  使用功能 数据连接功能 列表
export function dxSyDataConnectionList(params) {
  return request({
    url: "/sygn.sygnDataConnection/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 数据连接功能 有效列表
export function dxSyDataConnectionValidlist(params) {
  return request({
    url: "/sygn.sygnDataConnection/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 数据连接功能 添加
export function dxSyDataConnectionAdd(data) {
  return request({
    url: "/sygn.sygnDataConnection/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 数据连接功能 编辑
export function dxSyDataConnectionEdit(data) {
  return request({
    url: "/sygn.sygnDataConnection/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 数据连接功能 删除
export function dxSyDataConnectionDel(data) {
  return request({
    url: "/sygn.sygnDataConnection/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 数据连接功能 详情
export function dxSyDataConnectionDetail(params) {
  return request({
    url: "/sygn.sygnDataConnection/detail",
    method: "get",
    params
  });
}


// 检修情况  使用功能 侧键 列表
export function dxSySideKeyList(params) {
  return request({
    url: "/sygn.sygnSideKey/lists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 侧键 有效列表
export function dxSySideKeyValidlist(params) {
  return request({
    url: "/sygn.sygnSideKey/validLists",
    method: "get",
    params
  });
}
// 检修情况  使用功能 侧键 添加
export function dxSySideKeyAdd(data) {
  return request({
    url: "/sygn.sygnSideKey/add",
    method: "post",
    data
  });
}
// 检修情况  使用功能 侧键 编辑
export function dxSySideKeyEdit(data) {
  return request({
    url: "/sygn.sygnSideKey/edit",
    method: "post",
    data
  });
}
// 检修情况  使用功能 侧键 删除
export function dxSySideKeyDel(data) {
  return request({
    url: "/sygn.sygnSideKey/delete",
    method: "post",
    data
  });
}
// 检修情况  使用功能 侧键 详情
export function dxSySideKeyDetail(params) {
  return request({
    url: "/sygn.sygnSideKey/detail",
    method: "get",
    params
  });
}


// -----------------------------------------  等级设置---------------------------
// 登记选择 列表
export function dxSyPhoneLevelList(params) {
  return request({
    url: "/phone.phoneLevel/lists",
    method: "get",
    params
  });
}
// 登记选择 有效列表
export function dxSyPhoneLevelValidlist(params) {
  return request({
    url: "/phone.phoneLevel/validLists",
    method: "get",
    params
  });
}
// 登记选择 添加
export function dxSyPhoneLevelAdd(data) {
  return request({
    url: "/phone.phoneLevel/add",
    method: "post",
    data
  });
}
// 登记选择 编辑
export function dxSyPhoneLevelEdit(data) {
  return request({
    url: "/phone.phoneLevel/edit",
    method: "post",
    data
  });
}
// 登记选择 删除
export function dxSyPhoneLevelDel(data) {
  return request({
    url: "/phone.phoneLevel/delete",
    method: "post",
    data
  });
}
// 登记选择 详情
export function dxSyPhoneLevelDetail(params) {
  return request({
    url: "/phone.phoneLevel/detail",
    method: "get",
    params
  });
}


// 待拍库 列表
export function dxwaitSalePhoneList(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/lists",
    method: "get",
    params
  });
}
// 待拍库 添加
export function dxwaitSalePhoneAdd(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/add",
    method: "post",
    data
  });
}
// 待拍库 编辑
export function dxwaitSalePhoneEdit(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/edit",
    method: "post",
    data
  });
}
// 待拍库 删除
export function dxwaitSalePhoneDel(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/delete",
    method: "post",
    data
  });
}
// 待拍库 详情
export function dxwaitSalePhoneDetail(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/detail",
    method: "get",
    params
  });
}
// 待拍库 查询序列号
export function dxwaitSalePhoneNumber(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/getDetailBySerialNumber",
    method: "get",
    params
  });
}
// 待拍库 核价
export function dxwaitSalePhonePricing(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/pricing",
    method: "post",
    data
  });
}
// 待拍库 上下线
export function dxwaitSalePhoneOnline(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/online",
    method: "post",
    data
  });
}
// 待拍库 修改价格
export function dxwaitSalePhoneChange(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/setStartingBid",
    method: "post",
    data
  });
}
// 待拍库 操作记录
export function dxwaitSalePhoneEditlist(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/editLists",
    method: "get",
    params
  });
}
// 待拍库 待排列表
export function dxwaitSalePhoneWait(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/waitBiddingLists",
    method: "get",
    params
  });
}
// 待拍库 提交到核价库
export function dxwaitSalePhoneSubmitPricing(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/submitPricing",
    method: "post",
    data
  });
}
// 待拍库 退回质检库
export function dxwaitSalePhoneReturnDraft(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/returnDraft",
    method: "post",
    data
  });
}
// 待拍库 退回核价库
export function dxwaitSalePhoneReturnPricing(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/returnPricing",
    method: "post",
    data
  });
}
// 质检库 扫码上传  获取二维码
export function dxwaitSalePhoneUploadQrCode(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/uploadQrCode",
    method: "post",
    data
  });
}
// 质检库 扫码上传  刷新获取附件
export function dxwaitSalePhoneGetFiles(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/getJxqkFiles",
    method: "post",
    data
  });
}
// 质检库 扫码上传  删除附件
export function dxwaitSalePhoneFilesDel(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/jxqkFilesDelete",
    method: "post",
    data
  });
}
// 质检库 扫码上传  机框  获取二维码
export function dxwaitSaleUploadQrCodeFile(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/uploadPhoneFileQrCode",
    method: "post",
    data
  });
}
// 质检库 扫码上传  机框  刷新获取附件
export function dxwaitSalePhoneFiles(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/getPhoneFiles",
    method: "post",
    data
  });
}

// 任务库 列表
export function dxTaskList(params) {
  return request({
    url: "/task_library.taskLibrary/lists",
    method: "get",
    params
  });
}
// 任务库 添加
export function dxTaskAdd(data) {
  return request({
    url: "/task_library.taskLibrary/add",
    method: "post",
    data
  });
}
// 任务库 编辑
export function dxTaskEdit(data) {
  return request({
    url: "/task_library.taskLibrary/edit",
    method: "post",
    data
  });
}
// 任务库 删除
export function dxTaskDel(data) {
  return request({
    url: "/task_library.taskLibrary/delete",
    method: "post",
    data
  });
}
// 任务库 详情
export function dxTaskDetail(params) {
  return request({
    url: "/task_library.taskLibrary/detail",
    method: "get",
    params
  });
}
// 任务库 上下线
export function dxTaskOnline(data) {
  return request({
    url: "/task_library.taskLibrary/online",
    method: "post",
    data
  });
}
// 任务库 生成海报
export function dxTaskPoster(data) {
  return request({
    url: "/task_library.taskLibrary/poster",
    method: "post",
    data
  });
}
// 任务库 成交
export function dxTaskDeal(data) {
  return request({
    url: "/task_library.taskLibrary/deal",
    method: "post",
    data
  });
}
// 任务库 出价记录
export function dxTaskBidRanking(params) {
  return request({
    url: "/task_library.taskLibrary/bidRanking",
    method: "get",
    params
  });
}
// 任务库 添加手机
export function dxTaskAddPhone(data) {
  return request({
    url: "/task_library.taskLibrary/addPhone",
    method: "post",
    data
  });
}
// 任务库 删除手机
export function dxTaskDelPhone(data) {
  return request({
    url: "/task_library.taskLibrary/deletePhone",
    method: "post",
    data
  });
}
// 任务库 手机列表
export function dxTaskPhoneList(params) {
  return request({
    url: "/task_library.taskLibrary/taskLibraryPhoneLists",
    method: "get",
    params
  });
}

// 任务库 退回至质检库
export function dxTaskReturnDraft(data) {
  return request({
    url: "/task_library.taskLibrary/returnDraft",
    method: "post",
    data
  });
}
// 任务库 退回至核价库
export function dxTaskReturnPricing(data) {
  return request({
    url: "/task_library.taskLibrary/returnPricing",
    method: "post",
    data
  });
}
// 任务库 退回至待拍库
export function dxTaskReturnWait(data) {
  return request({
    url: "/task_library.taskLibrary/returnWait",
    method: "post",
    data
  });
}

// 任务库 待确认订单
export function dxTaskPend(params) {
  return request({
    url: "/task_library.taskLibrary/taskLibraryEndUnconfirmedPhoneLists",
    method: "get",
    params
  });
}
// 任务库 领取待确认订单
export function dxTaskPendClaimOrder(data) {
  return request({
    url: "/task_library.taskLibrary/claimOrder",
    method: "post",
    data
  });
}
// 任务库 移除待确认订单
export function dxTaskPendRemoveOrder(data) {
  return request({
    url: "/task_library.taskLibrary/removeOrder",
    method: "post",
    data
  });
}
// 待确认订单  删除手机数据
export function dxreturnDraftDelete(data) {
  return request({
    url: "/task_library.taskLibrary/returnDraftDelete",
    method: "post",
    data
  });
}
// 待确认订单  丢单成交
export function dxlostOrderDeal(data) {
  return request({
    url: "/task_library.taskLibrary/lostOrderDeal",
    method: "post",
    data
  });
}


// 质检库 领取认领
export function dxWaitSaleClaimDraft(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/claimDraft",
    method: "post",
    data
  });
}
// 质检库 移除认领 
export function dxWaitSaleRemoveDraft(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/removeDraft",
    method: "post",
    data
  });
}
// 核价库 领取认领
export function dxWaitSaleClaimPricing(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/claimPricing",
    method: "post",
    data
  });
}
// 核价库 移除认领 
export function dxWaitSaleRemovePricing(data) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/removePricing",
    method: "post",
    data
  });
}
// 核价库 我的
export function dxWaitSaleList(params) {
  return request({
    url: "/wait_sale_phone.waitSalePhone/lists",
    method: "get",
    params
  });
}

// 任务库  退款异常
export function dxTaskTefundAnomaly(params) {
  return request({
    url: "/task_library.taskLibrary/taskLibraryTefundAnomalyLists",
    method: "get",
    params
  });
}

// 任务库  退款异常
export function dxreturnGoods(data) {
  return request({
    url: "/task_library.taskLibrary/returnGoods",
    method: "post",
    data
  });
}

// 任务库  退款异常  查询情况
export function dxreturnInfo(params) {
  return request({
    url: "/task_library.taskLibrary/bidderRefundInfo",
    method: "get",
    params
  });
}

// 任务库  退款异常  修改信息
export function dxreturnInfoedit(data) {
  return request({
    url: "/task_library.taskLibrary/editRefundInfo",
    method: "post",
    data
  });
}

// 公告提示
export function dxNoticeLists(params) {
  return request({
    url: "/notice.noticeTip/lists",
    method: "get",
    params
  });
}
// 公告提示
export function dxNoticeAdd(data) {
  return request({
    url: "/notice.noticeTip/add",
    method: "post",
    data
  });
}
// 公告提示
export function dxNoticeEdit(data) {
  return request({
    url: "/notice.noticeTip/edit",
    method: "post",
    data
  });
}
// 公告提示
export function dxNoticeDelete(data) {
  return request({
    url: "/notice.noticeTip/delete",
    method: "post",
    data
  });
}
// 公告提示
export function dxNoticeDetail(params) {
  return request({
    url: "/notice.noticeTip/detail",
    method: "get",
    params
  });
}

// banner
export function dxBannerLists(params) {
  return request({
    url: "/banner.bannerImage/lists",
    method: "get",
    params
  });
}
// banner
export function dxBannerAdd(data) {
  return request({
    url: "/banner.bannerImage/add",
    method: "post",
    data
  });
}
// banner
export function dxBannerEdit(data) {
  return request({
    url: "/banner.bannerImage/edit",
    method: "post",
    data
  });
}
// banner
export function dxBannerDelete(data) {
  return request({
    url: "/banner.bannerImage/delete",
    method: "post",
    data
  });
}
// banner
export function dxBannerDetail(params) {
  return request({
    url: "/banner.bannerImage/detail",
    method: "get",
    params
  });
}

